// remove contract in review contract
export default function removeSellerResponse($http) {
  'ngInject';

  return function (responseId) {
    console.warn(
      'The removeSellerResponse service has been deprecated and will be removed from a future release.'
    );

    return $http.get(
      '/aptitude/buyer/BuyerContractingServiceController/removeResponse',
      {
        params: {
          responseId: responseId
        }
      }
    );
  };
}
